import { Component, OnInit } from '@angular/core';
import { CoursewareService } from 'src/services/CoursewareService';
import { MemberUserData } from 'src/model/User/MemberUserData';
import { Error } from 'src/model/Error';
import { AlertService } from '../_alert';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { globals } from '../shared/globals';
import { Title } from '@angular/platform-browser';
import { PreviousRouteService } from '../../services/PreviousRouteService';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public static user: MemberUserData;
  headers;

  constructor(private previousRouteService: PreviousRouteService, private titleService: Title, private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) {
    this.titleService.setTitle("Log In - LawShelf Educational Media");
  }

  public getUserName() {
    if (globals.userName)
      return globals.userName;
    return null;
  }

  ngOnInit() {
  }

  public doLogin(form: NgForm) {
    this.alertService.clear();
    this.coursewareService.Login(form.value.email, form.value.password).subscribe(data => {
      LoginComponent.user = data as MemberUserData;
      if (LoginComponent.user && LoginComponent.user.FullName) {
        globals.userName = LoginComponent.user.FullName;
        globals.token = LoginComponent.user.Token;
        if (typeof window !== 'undefined') {
          localStorage.setItem("token", globals.token);
          localStorage.setItem("username", globals.userName);
        }
        if (this.previousRouteService.getPreviousUrl() == null || this.previousRouteService.getPreviousUrl() === '/loginview') {
          console.log("navigating to videosview ");
          this._router.navigate(['/videocoursesview']);
        } else {
          console.log("navigating to previous url " + this.previousRouteService.getPreviousUrl());
          this._router.navigate([this.previousRouteService.getPreviousUrl()]);
        }
      } else {
        let error = data as Error
        this.alertService.error(error.Message);
      }
    },
      error => this.alertService.error("Caught unexpected error when logging in " + error.Message));
  }
}
